module.exports = __webpack_public_path__ + "d2482b166537ecd5614c7c839ca54ab4.ttf";